import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { portfolio, project }: Boundaries["removeProjectFromPortfolio"]["request"],
): State {
  const index = state.findIndex(
    (req) =>
      req.portfolio.uuid === portfolio.uuid &&
      req.project.uuid === project.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { portfolio, project, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { portfolio, project, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { portfolio, project }: Boundaries["removeProjectFromPortfolio"]["success"],
): State {
  const index = state.findIndex(
    (req) =>
      req.portfolio.uuid === portfolio.uuid &&
      req.project.uuid === project.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { portfolio, project, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { portfolio, project, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { portfolio, project }: Boundaries["removeProjectFromPortfolio"]["failure"],
): State {
  const index = state.findIndex(
    (req) =>
      req.portfolio.uuid === portfolio.uuid &&
      req.project.uuid === project.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { portfolio, project, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { portfolio, project, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeProjectFromPortfolioRequested]: handleRequest,
    [events.removeProjectFromPortfolioSucceeded]: handleSuccess,
    [events.removeProjectFromPortfolioFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
